// extracted by mini-css-extract-plugin
module.exports = {"container":"az_fUb","contentContainer":"az_gUb","linkButton":"az_hUb","heading":"az_iUb","description":"az_jUb"};